<template>
  <label class="ui-field">
    <span v-if="label">{{ label }}</span>
    <select class="ui-select" :value="modelValue" :disabled="disabled" @change="$emit('update:modelValue', $event.target.value)">
      <option v-for="opt in normalizedOptions" :key="opt.value" :value="opt.value">
        {{ opt.label }}
      </option>
    </select>
  </label>
</template>

<script>
export default {
  name: 'UiSelect',
  props: {
    label: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: [String, Number],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  computed: {
    normalizedOptions() {
      return this.options.map(opt => {
        if (typeof opt === 'object' && opt !== null) {
          return { label: opt.label || opt.text || '', value: opt.value != null ? opt.value : '' }
        }
        return { label: String(opt), value: opt }
      })
    }
  }
}
</script>
